import React, { type JSX } from 'react';
import { Chip } from '@mui/material';

const CATEGORY_STYLES: Record<string, { bg: string; color: string; label: string }> = {
  '0_IDEAL':    { bg: '#E0FCF0', color: '#26835B', label: 'IDEAL' },
  '1_LOW':      { bg: '#E0F7FA', color: '#00838F', label: 'LOW' },
  '2_MEDIUM':   { bg: '#FFFDE7', color: '#F9A825', label: 'MEDIUM' },
  '3_HIGH':     { bg: '#FFE9CC', color: '#F5A73F', label: 'HIGH' },
  '5_CRITICAL': { bg: '#FFCCCC', color: '#E50000', label: 'CRITICAL' },
};

interface Props {
  value: string | null | undefined;
}

const ScoringCategoryBadge = ({ value }: Props): JSX.Element | null => {
  if (!value) return <span>—</span>;
  const style = CATEGORY_STYLES[value];
  if (!style) return <span>{value}</span>;
  return (
    <Chip
      label={style.label}
      size="small"
      sx={{ backgroundColor: style.bg, color: style.color, fontSize: '12px' }}
    />
  );
};

export default ScoringCategoryBadge;
